<template>
	<div class="countdown">
		{{arr[3]}}时{{arr[4]}}分
	</div>
</template>
<script>
	export default {
		data(){
			return{
				arr:[],
				countdownObj:null,
			}
		},
		props:{
			stamp:{
				default:'',
			}
		},
		watch:{
			stamp(n){
				if(n){
					this.getArr();
					this.countdownObj = setInterval(()=>{
						this.getArr();
					},5000)
				}
			}
		},
		mounted(){
			if(this.stamp){
				this.getArr();
				this.countdownObj = setInterval(()=>{
					this.getArr();
				},5000)
			}
		},
		methods: {
			getArr(){
				let str1 = (new Date().getTime()).toString().substring(0,10);
				let str2 = (Number(this.stamp)+86400).toString();
				this.arr = this.$public.FAge(str1,str2)
				if(Number(str1)>Number(str2)){
					clearInterval(this.countdownObj)
					this.$emit("stop")
				}
			}
		}
	}
</script>
<style scoped lang="scss">
.countdown{
	display: inline-block;
}
</style>
